export const getCookies = function () {
  let pairs = document.cookie.split(";");
  let cookies: { [key: string]: string } = {};
  pairs.map((pair,index)=>{
    let _pair = pair.split("=");
    cookies[(_pair[0] + '').trim()] = unescape(_pair.slice(1).join('='));
  })
  return cookies;
}